import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Page from './pages/Page';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <ScrollToTop />
      <Header />
      
      <main className="flex-grow">
        <Routes>
          {/* Home route */}
          <Route path="/" element={<Page />} />
          
          {/* Forbidden page */}
          <Route path="/403" element={<Forbidden />} />
          
          {/* Not Found page */}
          <Route path="/404" element={<NotFound />} />
          
          {/* Dynamic pages based on slug */}
          <Route path="/:slug" element={<Page />} />
          
          {/* Fallback to 404 */}
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}

export default App;
